export const classes = {
  root: {
    display: 'block',
    left: 0,
    right: 0,
  },
};
